/* eslint-disable react-hooks/exhaustive-deps */
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { InputAdornment, TextField } from '@mui/material';
import { validDecimal } from 'app/helpers/numberHelper';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsEmiLmoDisabled } from 'store/redux-store/placement-mods/selectors';

export const EmiCostPerDay = () => {
  const { control, formState: { errors }, setValue, clearErrors, getValues, setError } = useFormContext();
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const emiDaysWaived: number | string | null | undefined = useWatch({ name: 'emiDaysWaived' });
  const emiCostPerDay: number | string | null | undefined = useWatch({ name: 'emiCostPerDay' });
  const earlyMoveInDate: Date | string | null | undefined = useWatch({ name: 'earlyMoveInDate' });
  const emiNumberOfDays: number | string | null | undefined = useWatch({ name: 'emiNumberOfDays' });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const [fieldRequired, setFieldRequired] = useState<boolean>(false);

  useEffect(() => {
    if (
      (!isNullOrUndefined(earlyMoveInDate) && earlyMoveInDate !== '') ||
      (!isNullOrUndefined(getValues('emiCostPerDay')) && getValues('emiCostPerDay') !== '') ||
      (!isNullOrUndefined(getValues('emiNumberOfDays')) && getValues('emiNumberOfDays') !== '') ||
      (!isNullOrUndefined(getValues('emiDaysWaived')) && getValues('emiDaysWaived') !== '')
    ) {
      if (isNullOrUndefined(emiCostPerDay) || emiCostPerDay === '') {
        setError('emiCostPerDay', t('placement.placementMods.costPerDayError'));
      } else {
        clearErrors('emiCostPerDay');
      }
      setFieldRequired(true);
    } else {
      setFieldRequired(false);
    }
  }, [earlyMoveInDate, emiCostPerDay, emiDaysWaived, emiNumberOfDays]);

  useEffect(() => {
    if (!fieldRequired) {
      setTimeout(() => {
        clearErrors('emiCostPerDay');
      }, 100);
    }
  }, [fieldRequired]);

  return (
    <Controller
      control={control}
      name={'emiCostPerDay'}
      rules={{
        required: fieldRequired,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={emiCostPerDay}
          variant="filled"
          fullWidth
          id="emiCostPerDay"
          color="primary"
          label={t('placement.placementMods.costperDay')}
          InputLabelProps={{
            shrink: emiCostPerDay ? true : false,
            sx: { marginTop: emiCostPerDay ? '0px' : '-10px' },
          }}
          inputProps={{ maxLength: 6 }}
          InputProps={{
            readOnly: !isModEdit || isEmiLmoDisabled,
            style: {
              pointerEvents: (isModEdit || isSaveModApiCalling) && !isEmiLmoDisabled ? 'auto' : 'none',
            },
            startAdornment: <>{emiCostPerDay && <InputAdornment position="start">$</InputAdornment>}</>,
          }}
          onChange={e => {
            if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 4 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue('emiCostPerDay', validInput);
              onChange(validInput);
            }
          }}
          error={fieldRequired ? !!errors?.emiCostPerDay : false}
          helperText={!isNullOrUndefined(errors?.emiCostPerDay) ? errors?.emiCostPerDay?.message : undefined}
          disabled={isSaveModApiCalling}
          required={fieldRequired}
          {...rest}
        />
      )}
    />
  );
};
